
import { defineComponent, ref } from 'vue'
import { FreeSubscriptionsRouteNames, MembersRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import { useFreeSubscriptionsModule } from '@/modules/free-subscriptions'
import { usePackageModule } from '@/modules/packages'
import FreeSubscriptionsOpenDialogFieldPackages from '@/components/free-subscriptions/open-dialog-fields/packages.vue'
import { useMemberModule } from '@/modules/members'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'
import FreeSubscriptionsEditableFieldEndDate from '@/components/free-subscriptions/editable-fields/end-date.vue'

export default defineComponent({
    name: 'free-subscriptions-show-edit-free-subscription',
    components: {
        FreeSubscriptionsEditableFieldEndDate,
        FreeSubscriptionsOpenDialogFieldPackages
    },
    async setup () {
        const route = useRoute()
        const router = useRouter()
        const $q = useQuasar()
        const { getFreeSubscription, deleteFreeSubscription } = useFreeSubscriptionsModule()

        const freeSubscription = await getFreeSubscription(route.params.subscriptionId as string)
        const freeSubscriptionModel = ref(freeSubscription)
        const { getPackages } = usePackageModule()
        await getPackages()

        const { getMember, member } = useMemberModule()
        await getMember(freeSubscriptionModel.value.memberId as string)

        async function onDeleteFreeSubscription () {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'free subscription',
                    identifier: freeSubscriptionModel.value.subscriptionId,
                    deleteCallback: async () => {
                        await deleteFreeSubscription(freeSubscriptionModel.value.subscriptionId)
                        await router.push({
                            name: FreeSubscriptionsRouteNames.LIST,
                            query: { page: route.query.page ?? '1' },
                            params: { restoreFilters: 1 }
                        })
                    }
                }
            })
        }

        return {
            freeSubscriptionModel,
            FreeSubscriptionsRouteNames,
            MembersRouteNames,
            member,
            freeSubscription,
            route,
            onDeleteFreeSubscription
        }
    }
})
